import React from 'react';
import { UpdatePassword } from 'components';

function UpdatePasswordComponent() {
    return <UpdatePassword />;
}

export default UpdatePasswordComponent;
